import { Component, OnInit, ViewChild } from '@angular/core';
import { DashboardService } from 'app/core/services/dashboard.service';
import { ChartDataSets } from 'chart.js';
import { ChartOptions, ChartType } from 'chart.js';
import { Color, Label } from 'ng2-charts';

import * as _moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import * as Chart from 'chart.js';
const moment = _moment;

@Component({
  selector: 'app-transport-chart',
  templateUrl: './transport-chart.component.html',
  styleUrls: ['./transport-chart.component.scss']
})
export class TransportChartComponent implements OnInit {

  // public lineChartData: ChartDataSets[];
  // public lineChartLabels: Label[];

  public lineChartData: ChartDataSets[] = [
    { data: [], label: 'Transport fluvial' },
    { data: [], label: 'Transport terrestre' },
  ];
  public lineChartLabels: Label[] = [
  ];
  public lineChartOptions: (ChartOptions & { annotation?: any }) = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            stepSize: 1
          }
        }
      ]
    }
  };
  public lineChartColors: Color[] = [
    {
      borderColor: 'rgba(37, 175, 230, 1)',
      backgroundColor: 'rgba(117, 205, 240, 0.2)',
    },
    {
      borderColor: 'rgba(237, 221, 71, 1)',
      backgroundColor: 'rgba(255, 242, 122, 0.2)',
    }
  ];
  public lineChartLegend = true;
  public lineChartType = 'line' as ChartType;
  public lineChartPlugins = [];

  constructor(
    private dashboardService: DashboardService,
    private translateService: TranslateService,
  ) { }

  ngOnInit() {
    this.lineChartLabels = [
      // this.translateService.instant('month-' + moment().add(-6, 'months').get('month')),
      this.translateService.instant('label.month-' + (moment().add(-5, 'months').get('month') + 1)),
      this.translateService.instant('label.month-' + (moment().add(-4, 'months').get('month') + 1)),
      this.translateService.instant('label.month-' + (moment().add(-3, 'months').get('month') + 1)),
      this.translateService.instant('label.month-' + (moment().add(-2, 'months').get('month') + 1)),
      this.translateService.instant('label.month-' + (moment().add(-1, 'months').get('month') + 1)),
      this.translateService.instant('label.month-' + (moment().get('month') + 1))
    ]
    this.dashboardService.getDashboardTransport().subscribe(value => {
      value.tonnage?.forEach(tonnage => {
        if (this.lineChartData[0] && this.lineChartData[0].data) {
          this.lineChartData[0].data[5 - (moment().get('month') + 1 - tonnage.month)] = tonnage.counter
        }
      });
      value.toll?.forEach(toll => {
        if (this.lineChartData[1] && this.lineChartData[1].data) {
          this.lineChartData[1].data[5 - (moment().get('month') + 1 - toll.month)] = toll.counter
        }
      });
    });
  }

}
